import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Label } from 'web-ui-components/lib/atoms/forms';
import { StateIndicator } from 'web-ui-components/lib/typography/indicators';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import preReviewContent, { contentPropTypes } from './RatePreReviewSection.content';
import withContent from '../../../../containers/withContent';
import { isSpecificFormKeyValid } from '../../../../states/validation/selectors';

const mapState = (state) => ({
	isSendAmount: isSpecificFormKeyValid(state, 'iftPaymentDetails', 'sendAmount'),
	isRateBooked: isSpecificFormKeyValid(state, 'iftPaymentDetails', 'preBookedRate'),
	isPreBookedReference: isSpecificFormKeyValid(state, 'iftPaymentDetails', 'preBookedReference'),
	isDate: isSpecificFormKeyValid(state, 'iftPaymentDetails', 'date'),
});
export const getStateIndicator = (tableRowMapping, tableRowKey) => {
	if (tableRowMapping[tableRowKey]) {
		return (
			<StateIndicator.Active>
				<StandardBody isFlush>{tableRowKey}</StandardBody>
			</StateIndicator.Active>
		);
	}
	return (
		<StateIndicator.Editing>
			<StandardBody isFlush>{tableRowKey}</StandardBody>
		</StateIndicator.Editing>
	);
};
export const RatePreReviewSection = ({
	content: { header, currencyHeader, dateHeader, amountHeader, feesHeader, rateHeader },
	isSendAmount,
	isRateBooked,
	isPreBookedReference,
	isPreBookedRate,
	isPreBookedRateMandatory,
	isDate,
}) => {
	const tableRowMapping = {
		[currencyHeader]: true,
		...((isPreBookedRate || isPreBookedRateMandatory) && {
			[rateHeader]: isRateBooked && isPreBookedReference,
		}),
		[dateHeader]: isDate,
		[amountHeader]: isSendAmount,
		[feesHeader]: true,
	};
	return (
		<div>
			<div>
				<Label htmlFor="test">{header}</Label>
			</div>
			{Object.keys(tableRowMapping).map((tableRowKey) => (
				<div key={tableRowKey}>{getStateIndicator(tableRowMapping, tableRowKey)}</div>
			))}
		</div>
	);
};

RatePreReviewSection.propTypes = {
	content: PropTypes.shape(contentPropTypes),
	isSendAmount: PropTypes.bool.isRequired,
	isRateBooked: PropTypes.bool.isRequired,
	isPreBookedReference: PropTypes.bool.isRequired,
	isPreBookedRate: PropTypes.bool.isRequired,
	isPreBookedRateMandatory: PropTypes.bool.isRequired,
	isDate: PropTypes.bool.isRequired,
};
export default compose(connect(mapState), withContent({ content: preReviewContent }))(RatePreReviewSection);
